import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import ContactMe from "../../assets/svg/ContactMe";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  return (
      <div className="main contact-margin-top" id="contact">
        <div className="component-main">
        <Fade left duration={1000}>
            <div className="contact-left">
            <h1 className="component-heading">{contactInfo.title}</h1>
            <p
              className={
                isDark
                  ? "dark-mode contact-subtitle"
                  : "subTitle contact-subtitle"
              }
            >
              {contactInfo.subtitle}
            </p>
              <a
                className="contact-detail-email"
                href={"mailto:" + contactInfo.email_address}
              >
                {contactInfo.email_address}
              </a>
              <div
                className="location"
              >
              <a
              href={contactInfo.map_location}
              target="_blank" rel="noreferrer"
              >
              <span
                className="iconify"
                data-icon={"carbon:location"}
                data-inline="true"
              ></span>
              {" "+contactInfo.location}
             </a>
              <SocialMedia />
            </div>
          </div>
        </Fade>
          <Fade right duration={1000}>
            <div className="component-image-div">
              <ContactMe />
            </div>
          </Fade>
        </div>
      </div>
  );
}
